import { Moment } from "moment";
import { TransactionType } from "./enums";
import { Dayjs } from "dayjs";

export class DigitalWalletFilterRequest {
    keywords: string = "";
    employeeName: string = "";
    walletStatus?: string | null = null;
    employeeNumber: string = "";
    expiredDate?: Moment | null = null;
    employeeStatus?: boolean | null = null;
    phone: string = "";
    lastUseDate?: Moment | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
}

export class DigitalWalletFilterResponse {
    currentSubsidyBalanceOfAllEmployees: number = 0;
    currentBalanceInActiveWallets: number = 0;
    unpaidSubsidies: number = 0;
    subsidyBalance: number = 0;
    subsidyUsedPercentNotification: number = 0;
    total: number = 0;
    totalFilter: number = 0;
    hasNext: boolean = true;
    rows: DigitalWalletRowResult[] = [];
}

export class DigitalWalletRowResult {
    id: number = 0;
    status: string = "";
    expiredDate: string = "";
    employeeId: number = 0;
    employeeNumber: string = "";
    employeeName: string = "";
    employeeStatus: boolean = true;
    employeePhone: string = "";
    currentBalance: number = 0;
    lastUseDate: string = "";
    lastUsedAmount: number = 0;
    currencyId: number = 0;
}

export class DigitalWalletManagementFilterRequest {
    keywords: string = "";
    employeeName: string = "";
    fromDate?: Moment | null = null;
    tillDate?: Moment | null = null;
    walletStatus?: string | null = null;
    employeeStatus?: boolean | null = null;
    organizationUnitId?: number | null = null;
    employeeGroupId?: number | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
}

export class DigitalWalletManagementFilterResponse {
    currentSubsidyBalanceOfAllEmployees: number = 0;
    currentBalanceInActiveWallets: number = 0;
    unpaidSubsidies: number = 0;
    subsidyBalance: number = 0;
    subsidyUsedPercentNotification: number = 0;
    total: number = 0;
    totalFilter: number = 0;
    hasNext: boolean = true;
    rows: DigitalWalletManagementRowResult[] = [];
}

export class DigitalWalletManagementRowResult {
    id: number = 0;
    employeeId: number = 0;
    employeeNumber: string = "";
    employeeName: string = "";
    employeeStatus: boolean = true;
    employeeGroup: string = "";
    currentBalance: number = 0;
    walletExpiryDate: string = "";
    lastLoadingDate: string = "";
    walletStatus: string = "";
    currencyId: number = 0;
    newEmployee: boolean = false;
    organizationUnit: string = "";
}

export class BulkUpdateDigitalWalletsRequest {
    type: number = 0;
    digitalWallets: Array<number> = new Array<number>();
    isReset: boolean = false;
    amount?: number | null = null;
    expiredDate?: string | null = null;
}

export class BulkUpdateDigitalWalletsResponse {
    success: boolean = true;
}

export class EmployeeDigitalWalletFilterRequest {
    employeeId: number = 0;
    amount: number | null = null;
    keywords: string = "";
    fromDate: string | null = "";
    tillDate: string | null = "";
    transactionType: TransactionType | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
}

export class EmployeeDigitalWalletResponse {
    hasNext: boolean = true;
    employeeDigitalWalletInfo: EmployeeDigitalWalletInfo = new EmployeeDigitalWalletInfo();
    transactions: TransactionRowResult[] = [];
    total: number = 0;
    totalFilter: number = 0;
}

export class EmployeeDigitalWalletInfo {
    walletId: number = 0;
    walletBalance: number = 0;
    walletStatus: string = "";
    expiredDate: string = "";
    currencyId: number = 0;
}

export class TransactionRowResult {
    id: number = 0;
    transactionType: string = "";
    transactionDate: string = "";
    username: string | null = null;
    transactionAmount: number = 0;
    connectedOrderId: number | null = null;
    currencyId: number = 0;
    docket: string = "";
}

export class ExportDigitalWalletResponse {
    interfaceId: number = 0;
    success: boolean = false;
}

export class SearchDigitalWalletIdsResponse {
    error: string = "";
    rows: number[] = [];
}
